<!--
  Wrapper For Admin Table
    - Props
      - users [array] (required): Maps to row
      - headers [array] (required): Maps to cols
      - options [array] (optional):
        - cancelable [boolean]: Allows the loggedin User to cancel a sub that they are paying for
        - sortable [boolean]
        - showClients [boolean]: displays a link to a Nutritionist's clients
        - showGroupUsers [boolean]: displays a link to a Group's users
        - actions [array]:
          - edit: Redirects to User's edit page
          - inlineEdit: As the name suggests. Updates the state data on save. Currently only used for BulkUsers
          - delete: Removes the row from state
          - groupEdit: Redirects to Group's edit page
          - fileEdit: Redirects to file edit page
          - download: Download file stored in DO Space
          - subscriptionEdit: redirects to subscription edit page
    - Notes
      - This creates a local clone of Users to display. Safe to pass in state data
      - Methods that alter Users array should be emitted here from AdminTable
      - Methods found in AdminTable should only update the UI
-->

<template>
  <AdminTable
    :users="localUsers"
    :headers="headersClone"
    :options="options"
    v-on:handleDelete="handleDelete"
    v-on:handleUpdate="handleUpdate"/>
</template>

<script>
import { mapActions } from 'vuex'
import { cloneDeep } from 'lodash'
import AdminTable from './AdminTable'

export default {
  name: 'AdminTableContainer',
  components: { AdminTable },
  props: ['users', 'headers', 'options'],
  data() {
    return {
      localUsers: {}
    }
  },
  computed: {
    usersClone() {
      return cloneDeep(this.users)
    },
    headersClone() {
      return cloneDeep(this.headers)
    }
  },
  methods: {
    ...mapActions(['deleteUser', 'updateUser', 'resetNewUser']),
    handleDelete(e) {
      this.deleteUser(e.item.email)
    },
    handleUpdate(e) {
      this.updateUser(e)
    }
  },
  mounted() {
    this.resetNewUser()
    this.localUsers = this.usersClone
  },
  watch: {
    users: {
      handler: function () {
        this.localUsers = this.usersClone
      },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/components/AdminTableContainer.vue?7434dd22